/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { DtpContentContainer } from 'dtp-react-components';
import FiltroRelatorio from './FiltroRelatorio';
import Relatorio from './Relatorio';
import {
  buscaDestinatarios,
  doGet,
  doGetPaginado,
} from '../../utils/requests';
import { estadosRequerimento } from '../../utils/constants';
import { manterApenasFiltro } from '../../utils/helpers';

class TelaRelatorioRequerimentos extends Component {
  constructor(props) {
    super(props);
    this.state = {
      listaResultados: [],
      colunasRelatorio: [],
      nomeRelatorio: '',
      filtrosAtuais: {},
      dataFormatOptions: {},
      dataHistory: [],
      nomeRelatorioHistory: [],
      colunasHistory: [],
      dataFormatHistory: [],
      tipoRelatorioHistory: [],
      estadoRequerimentoAtual: null,
      solicitanteAtual: null,
      destinatarioAtual: null,
      competenciaSelecionada: null,
      nomeSolicitanteSelecionado: null,
      nomeDestinatarioSelecionado: null,
      exibirBotaoRelatorioAnalitico: false,
      tipoRelatorio: null,
      rowAtual: null,
    };
  }

  componentDidMount() {
    manterApenasFiltro('');
    if (this.props.destinatarios.length === 0 && this.isRgps()) {
      buscaDestinatarios(this.tratarErro);
    }
  }

  colunasRelatorioRequerimentos = [
    'Competência',
    'Solicitante',
    'Destinatário',
    'Aguardando Análise',
    'Aguardando An. Médica',
    'Aguardando Compensação Aposentadoria',
    'Análise Suspensa',
    'Compensado',
    'Criado',
    'Deferido',
    'Em Análise',
    'Em Compensação',
    'Em Exigência',
    'Indeferido',
    'Em Análise Perito Médico',
    'Alterado',
    'Exigência / Indeferido',
    'Indeferido Ratificado',
  ]

  colunasRelatorioAnaliticoGeral = [
    'NIT',
    'CPF',
    'Matrícula',
    'Protocolo',
    'Tipo Requerimento',
    'Tipo Aposentadoria',
    'Nome Beneficiario',
    'Dt. Criação Requerimento',
    'Dt. Situação',
    'Dias na Situação',
    'Migrado em',
  ]

  colunasRelatorioQuantExigencia = [
    'ID',
    'Exigência',
    'Quantidade',
  ]

  colunasRelatorioQuantEspecial = [
    'ID',
    'Motivo',
    'Quantidade',
  ]

  colunasRelatorioAnaliticoEspecial = [
    'NIT',
    'CPF',
    'Matrícula',
    'Protocolo',
    'Tipo Requerimento',
    'Tipo Aposentadoria',
    'Nome Beneficiario',
    'Dt. Criação Requerimento',
    'Dt. Situação',
    'Dias na Situação',
    'Nome do Analista',
    'Comentário Analista',
    'Migrado em',
  ]

  colunasRelatorioAnaliticoEspecialCompleto = [
    'NIT',
    'CPF',
    'Matrícula',
    'Protocolo',
    'Tipo Requerimento',
    'Tipo Aposentadoria',
    'Nome Beneficiario',
    'Dt. Criação Requerimento',
    'Dt. Situação',
    'Motivo',
    'Dias na Situação',
    'Nome do Analista',
    'Comentário Analista',
    'Migrado em',
  ]

  handlePesquisar = (valoresFiltro) => {
    const d1 = valoresFiltro.competenciaInicial;
    const d2 = valoresFiltro.competenciaFinal;

    if (d1.length !== 6 || d2.length !== 6) {
      this.addMessage('Competências devem ser no formato AAAA-MM');
      return;
    }

    const d1Ano = parseInt(d1.substring(2, 6), 10);
    const d2Ano = parseInt(d2.substring(2, 6), 10);
    const d1Mes = parseInt(d1.substring(0, 2), 10);
    const d2Mes = parseInt(d2.substring(0, 2), 10);

    if (d1Mes > 12) {
      this.addMessage('Competência inicial inválida.');
      return;
    }

    if (d2Mes > 12) {
      this.addMessage('Competência final inválida.');
      return;
    }

    if ((d2Ano < d1Ano) || (d2Ano === d1Ano && d2Mes < d1Mes)) {
      this.addMessage('Competência final deve ser maior ou igual a competência inicial');
      return;
    }
    let months = (d2Ano - d1Ano) * 12;
    months -= d1Mes;
    months += d2Mes;
    if (months > 12 || months < 0) {
      this.addMessage('Competência final deve ser no máximo 12 meses maior que a competência inicial');
      return;
    }

    if (!valoresFiltro['destinatario-rpps'] && !valoresFiltro.gex && months !== 0 && this.isRgps()) {
      this.addMessage('Com filtro de superintendência ou todos, intervalo máximo de competência deve ser um mês.');
      return;
    }

    this.setState({
      filtrosAtuais: valoresFiltro,
    }, () => this.executaConsulta(null, 'sintetico'));
  }

  isRgps = () => this.props.auth.checkPermission(['requerer-compensacao-rgps', 'analisar-compensacao-rgps', 'gerenciar-negocio-dcomp',
    'auditar-comprev', 'analisar-negocio-dtpv', 'consultar-compensacao-rgps', 'analisar-negocio-sprev']);

  defineCompetenciaFiltro = (row) => {
    const mes = row.mesCompetencia.toString().length === 1
      ? `0${row.mesCompetencia}` : row.mesCompetencia.toString();
    return row.anoCompetencia + mes;
  }

  defineNivelFiltro = () => {
    if (!this.isRgps()) {
      return 4;
    } else if (this.state.filtrosAtuais['destinatario-rpps']) {
      return 4;
    } else if (this.state.filtrosAtuais.ente) {
      return 4;
    } else if (this.state.filtrosAtuais.aps) {
      return 3;
    } else if (this.state.filtrosAtuais.gex) {
      return 2;
    } else if (this.state.filtrosAtuais.superintendencia) {
      return 1;
    }
    return 0;
  }

  defineCodigo = (parametros) => {
    const novosParametros = parametros;

    if (!this.isRgps()) {
      novosParametros.codigo = '01000';
    } else if (this.state.filtrosAtuais['destinatario-rpps']) {
      novosParametros.codigo = this.state.filtrosAtuais['destinatario-rpps'];
    } else if (this.state.filtrosAtuais.ente) {
      novosParametros.codigo = this.state.filtrosAtuais.ente;
    } else if (this.state.filtrosAtuais.aps) {
      novosParametros.codigo = this.state.filtrosAtuais.aps;
    } else if (this.state.filtrosAtuais.gex) {
      novosParametros.codigo = this.state.filtrosAtuais.gex;
    } else if (this.state.filtrosAtuais.superintendencia) {
      novosParametros.codigo = this.state.filtrosAtuais.superintendencia;
    }
    return novosParametros;
  }

  recuperarCodigoParticipanteExibicao = (nomeParticipante) => {
    let retorno = '';
    if (nomeParticipante !== null && nomeParticipante !== '') {
      retorno = nomeParticipante.substring((nomeParticipante.lastIndexOf('-') + 1), nomeParticipante.length);
    }
    return retorno;
  }

  defineOutroParticipante = (row) => {
    let solicitante = null;
    let destinatario = null;

    if (row.solicitante) {
      // solicitante = row.solicitante === 'RGPS' ? '01000' : row.solicitante.split('-')[1];
      // destinatario = row.destinatario === 'RGPS' ? '01000' : row.destinatario.split('-')[1];
      solicitante = row.solicitante === 'RGPS' ? '01000' : this.recuperarCodigoParticipanteExibicao(row.solicitante);
      destinatario = row.destinatario === 'RGPS' ? '01000' : this.recuperarCodigoParticipanteExibicao(row.destinatario);
    } else {
      solicitante = this.state.solicitanteAtual;
      destinatario = this.state.destinatarioAtual;
    }

    if (this.isRgps()) {
      return solicitante === '01000' ? destinatario : solicitante;
    }
    return solicitante === '01000' ? solicitante : destinatario;
  }

  defineModalidadeSemModalidade = (row) => {
    let solicitante = null;
    let destinatario = null;

    if (row.solicitante) {
      // solicitante = row.solicitante === 'RGPS' ? '01000' : row.solicitante.split('-')[1];
      // destinatario = row.destinatario === 'RGPS' ? '01000' : row.destinatario.split('-')[1];
      solicitante = row.solicitante === 'RGPS' ? '01000' : this.recuperarCodigoParticipanteExibicao(row.solicitante);
      destinatario = row.destinatario === 'RGPS' ? '01000' : this.recuperarCodigoParticipanteExibicao(row.destinatario);
    } else {
      solicitante = this.state.solicitanteAtual;
      destinatario = this.state.destinatarioAtual;
    }

    if (this.isRgps()) {
      return destinatario === '01000' ? 'solicitante' : 'destinatario';
    }
    return solicitante === '01000' ? 'solicitante' : 'destinatario';
  }

  executaConsulta = (row, relatorio, estado, idMotivo, motivo) => {
    let urlRelatorio = null;
    let solicitanteAtual = null;
    let destinatarioAtual = null;
    let paginado = false;
    let solCod = null;

    this.setState({ rowAtual: row });

    if (row && row.solicitante) {
      // solicitanteAtual = row.solicitante === 'RGPS' ? '01000' : row.solicitante.split('-')[1];
      // destinatarioAtual = row.destinatario === 'RGPS' ? '01000' : row.destinatario.split('-')[1];
      solicitanteAtual = row.solicitante === 'RGPS' ? '01000' : this.recuperarCodigoParticipanteExibicao(row.solicitante);
      destinatarioAtual = row.destinatario === 'RGPS' ? '01000' : this.recuperarCodigoParticipanteExibicao(row.destinatario);
    }

    let parametros = {
      nivel: this.defineNivelFiltro(relatorio),
      modalidadeRelacao: this.state.filtrosAtuais.relacao,
    };

    if (row !== null) {
      let filtroCompetenciaConsultada = '';
      let paramCompetencia = '';
      let paramSolicitanteAtual = '';
      let paramDestinatarioAtual = '';

      if (row.competencia) {
        filtroCompetenciaConsultada = this.textoParaNumeroCompetencia(row.competencia);
        paramCompetencia = row.competencia;
        paramSolicitanteAtual = row.solicitante;
        paramDestinatarioAtual = row.destinatario;
      } else {
        filtroCompetenciaConsultada =
        this.textoParaNumeroCompetencia(this.state.competenciaSelecionada);
        paramCompetencia = this.state.competenciaSelecionada;
        paramSolicitanteAtual = this.state.nomeSolicitanteSelecionado;
        paramDestinatarioAtual = this.state.nomeDestinatarioSelecionado;
      }
      parametros.competenciaConsultada = filtroCompetenciaConsultada;

      this.setState({
        nomeSolicitanteSelecionado: paramSolicitanteAtual,
        nomeDestinatarioSelecionado: paramDestinatarioAtual,
        competenciaSelecionada: paramCompetencia,
      });
    } else {
      const filtroCompetenciaInicial = this.state.filtrosAtuais.competenciaInicial.substring(2, 6) +
      this.state.filtrosAtuais.competenciaInicial.substring(0, 2);
      const filtroCompetenciaFinal = this.state.filtrosAtuais.competenciaFinal.substring(2, 6) +
      this.state.filtrosAtuais.competenciaFinal.substring(0, 2);
      parametros.competenciaInicial = filtroCompetenciaInicial;
      parametros.competenciaFinal = filtroCompetenciaFinal;
    }

    parametros = this.defineCodigo(parametros);

    if (!this.isRgps() && solicitanteAtual !== '01000' && destinatarioAtual !== '01000' &&
    (relatorio === 'analitico-geral' || relatorio === 'quantitativo-exigencia' || relatorio === 'quantitativo-especial')) {
      parametros.codigo = solicitanteAtual;
    } else if (!this.isRgps() && solicitanteAtual !== '01000' && destinatarioAtual !== '01000' && relatorio !== 'sintetico') {
      solCod = this.state.nomeSolicitanteSelecionado;
      parametros.codigo = solCod.substring(solCod.length - 5, solCod.length);
    }

    if (relatorio !== 'sintetico') {
      parametros.outroParticipante = this.defineOutroParticipante(row);
      parametros.estadoRequerimento = estado;
      if (this.state.filtrosAtuais.relacao === 'todos') {
        parametros.modalidadeSemModalidade = this.defineModalidadeSemModalidade(row);
      }
      paginado = true;
    }

    if (relatorio === 'sintetico') {
      urlRelatorio = 'filtro-requerimentos-sintetico';
    } else if (relatorio === 'analitico-geral') {
      urlRelatorio = 'filtro-requerimentos-analitico';
    } else if (relatorio === 'quantitativo-exigencia') {
      urlRelatorio = 'filtro-requerimentos-analitico-totalizador-exigencia';
    } else if (relatorio === 'quantitativo-especial') {
      urlRelatorio = 'filtro-requerimentos-analitico-totalizador-motivo';
    } else if (relatorio === 'analitico-especial') {
      urlRelatorio = 'filtro-requerimentos-analitico-motivo-exigencia';
      parametros.idMotivoExigencia = idMotivo != null ? idMotivo : '';
    } else if (relatorio === 'analitico-especial-completo') {
      urlRelatorio = 'filtro-requerimentos-analitico-motivo-exigencia-completo';
      parametros.motivoCompleto = 1;
    }

    this.setState({
      dataHistory: [...this.state.dataHistory, this.state.listaResultados],
      nomeRelatorioHistory: [...this.state.nomeRelatorioHistory, this.state.nomeRelatorio],
      colunasHistory: [...this.state.colunasHistory, this.state.colunasRelatorio],
      dataFormatHistory: [...this.state.dataFormatHistory, this.state.dataFormatOptions],
      tipoRelatorioHistory: [...this.state.tipoRelatorioHistory, this.state.tipoRelatorio],
      estadoRequerimentoAtual: estado,
      solicitanteAtual: solicitanteAtual == null ? this.state.solicitanteAtual : solicitanteAtual,
      destinatarioAtual: destinatarioAtual == null ?
        this.state.destinatarioAtual : destinatarioAtual,
    }, () => this.preparaRequest(urlRelatorio, relatorio, motivo, parametros, paginado));
  };

  preparaRequest = (urlRelatorio, relatorio, motivo, parametros, paginado) => {
    if (paginado) {
      doGetPaginado(`relatorios-requerimentos/${urlRelatorio}`, this.tratarSucesso(relatorio, motivo), this.tratarErro, parametros, 10000);
    } else {
      doGet(`relatorios-requerimentos/${urlRelatorio}`, this.tratarSucesso(relatorio, motivo), this.tratarErro, parametros);
    }
  }

  tratarSucesso = (relatorio, motivo) => (response) => {
    if (response.data !== '') {
      let novoNome = '';
      let novasColunas = [];
      let dataFormatOptions = {};
      let paramExibirBotaoRelatorioAnalitico = '';
      const competencia = `- ${this.state.competenciaSelecionada}`;
      const solicitante = ` - solicitante: ${this.state.nomeSolicitanteSelecionado}`;
      const destinatario = ` - destinatário: ${this.state.nomeDestinatarioSelecionado}`;
      const complementoTitulo = `${competencia}${solicitante}${destinatario}`;
      if (relatorio === 'sintetico') {
        novoNome = 'Relatório de Requerimentos Sintético';
        novasColunas = this.colunasRelatorioRequerimentos;
        dataFormatOptions = this.sinteticoDataFormatOptions;
      } else if (relatorio === 'analitico-geral') {
        novoNome = `Relatório de Requerimentos Analítico ${complementoTitulo}`;
        novasColunas = this.colunasRelatorioAnaliticoGeral;
        // A coluna Competência Cessação só aparece se o
        // estado do requerimento clicado no link for Compensado.
        if (this.state.estadoRequerimentoAtual === 11) {
          novasColunas.push('Competência Cessação');
        } else {
          const index = novasColunas.findIndex(item => (item === 'Competência Cessação'));
          if (index !== -1) {
            novasColunas.splice(index, 1);
          }
        }
        dataFormatOptions = this.analiticoDataFormatOptions;
      } else if (relatorio === 'quantitativo-exigencia') {
        novoNome = `Relatório Quantitativo de Exigências ${complementoTitulo}`;
        novasColunas = this.colunasRelatorioQuantExigencia;
        dataFormatOptions = this.quantExigenciasDataFormatOptions;
      } else if (relatorio === 'quantitativo-especial') {
        novoNome = `Relatório Quantitativo de Motivos ${complementoTitulo}`;
        novasColunas = this.colunasRelatorioQuantEspecial;
        dataFormatOptions = this.quantEspecialDataFormatOptions;
        paramExibirBotaoRelatorioAnalitico = true;
      } else if (relatorio === 'analitico-especial') {
        novoNome = `Relatório de Requerimentos Analítico com motivo "${motivo != null ? motivo : ''}"
        ${complementoTitulo}`;
        novasColunas = this.colunasRelatorioAnaliticoEspecial;
        dataFormatOptions = this.analiticoEspecialDataFormatOptions;
        paramExibirBotaoRelatorioAnalitico = false;
      } else if (relatorio === 'analitico-especial-completo') {
        novoNome = `Relatório de Requerimentos Analítico com motivo "${motivo != null ? motivo : ''}"
        ${complementoTitulo}`;
        novasColunas = this.colunasRelatorioAnaliticoEspecialCompleto;
        dataFormatOptions = this.analiticoEspecialDataFormatOptions;
        paramExibirBotaoRelatorioAnalitico = false;
      }

      this.setState({
        listaResultados: response.data,
        colunasRelatorio: novasColunas,
        nomeRelatorio: novoNome,
        dataFormatOptions,
        exibirBotaoRelatorioAnalitico: paramExibirBotaoRelatorioAnalitico,
        tipoRelatorio: relatorio,
      });
    }
  }

  addMessage = (text) => {
    const message = {
      title: 'Titulo',
      text,
      timeout: 5000,
      type: 'danger',
    };
    window.DtpSnackbar.addMessage(message);
  };

  tratarErro = (error) => {
    if (error) {
      const { data } = { ...error };
      if (error.status) {
        if (error.status === 404) {
          this.addMessage('Nenhum resultado encontrado para o filtro informado.');
        } else {
          this.addMessage(`${data.mensagem}`);
        }
      } else {
        this.addMessage('Ocorreu uma falha de comunicação com o serviço de compensação previdenciária.');
      }
    }
  };

  handleVoltar = () => {
    const { tipoRelatorio } = { ...this.state };
    const data = this.state.dataHistory.pop();

    if (tipoRelatorio === 'analitico-geral') {
      const novasColunas = this.colunasRelatorioAnaliticoGeral;
      const index = novasColunas.findIndex(item => (item === 'Competência Cessação'));
      if (index !== -1) {
        novasColunas.splice(index, 1);
      }
    }
    this.setState({
      listaResultados: data,
      colunasRelatorio: this.state.colunasHistory.pop(),
      nomeRelatorio: this.state.nomeRelatorioHistory.pop(),
      dataFormatOptions: this.state.dataFormatHistory.pop(),
      tipoRelatorio: this.state.tipoRelatorioHistory.pop(),
    });
  }

  textoParaNumeroCompetencia = (competencia) => {
    let numeroCompetencia = '';
    const ano = competencia.toString().slice(competencia.length - 4);

    if (competencia.indexOf('jan') !== -1) {
      numeroCompetencia = `${ano}01`;
    }
    if (competencia.indexOf('fev') !== -1) {
      numeroCompetencia = `${ano}02`;
    }
    if (competencia.indexOf('mar') !== -1) {
      numeroCompetencia = `${ano}03`;
    }
    if (competencia.indexOf('abr') !== -1) {
      numeroCompetencia = `${ano}04`;
    }
    if (competencia.indexOf('mai') !== -1) {
      numeroCompetencia = `${ano}05`;
    }
    if (competencia.indexOf('jun') !== -1) {
      numeroCompetencia = `${ano}06`;
    }
    if (competencia.indexOf('jul') !== -1) {
      numeroCompetencia = `${ano}07`;
    }
    if (competencia.indexOf('ago') !== -1) {
      numeroCompetencia = `${ano}08`;
    }
    if (competencia.indexOf('set') !== -1) {
      numeroCompetencia = `${ano}09`;
    }
    if (competencia.indexOf('out') !== -1) {
      numeroCompetencia = `${ano}10`;
    }
    if (competencia.indexOf('nov') !== -1) {
      numeroCompetencia = `${ano}11`;
    }
    if (competencia.indexOf('dez') !== -1) {
      numeroCompetencia = `${ano}12`;
    }
    return numeroCompetencia;
  }

  montaColuna = (relatorio, estado, tipo) => (cell, row) => {
    let valor = cell;
    let estadoAtual = estado;
    const motivoAtual = row.motivo ? row.motivo : row.exigencia;

    if (tipo === 'numero') {
      valor = new Intl.NumberFormat('pt-BR').format(cell);
    } else if (tipo === 'cpf') {
      valor = cell.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, '$1.$2.$3-$4');
    } else if (tipo === 'cnpj') {
      valor = cell.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g, '$1.$2.$3/$4-$5');
    }

    let id = null;
    if (estado === estadosRequerimento.EM_EXIGENCIA) {
      id = row.idExigencia;
    } else if ([estadosRequerimento.INDEFERIDO,
      estadosRequerimento.ANALISE_SUSPENSA,
      estadosRequerimento.COMPENSADO].includes(this.state.estadoRequerimentoAtual)) {
      id = row.idMotivo;
    }

    if (relatorio === 'analitico-especial') {
      estadoAtual = this.state.estadoRequerimentoAtual;
    }

    return (
      <React.Fragment>
        { relatorio ?
          (<a href="#" onClick={() => this.executaConsulta(row, relatorio, estadoAtual, id, motivoAtual)}>{valor}</a>)
        : (valor)
        }
      </React.Fragment>
    );
  }

  sinteticoDataFormatOptions = {
    3: this.montaColuna('analitico-geral', estadosRequerimento.AGUARDANDO_ANALISE),
    4: this.montaColuna('analitico-geral', estadosRequerimento.AGUARDANDO_ANALISE_MEDICO),
    5: this.montaColuna('analitico-geral', estadosRequerimento.AGUARDANDO_COMPENSACAO_APOSENTADORIA),
    6: this.montaColuna('quantitativo-especial', estadosRequerimento.ANALISE_SUSPENSA),
    7: this.montaColuna('quantitativo-especial', estadosRequerimento.COMPENSADO),
    8: this.montaColuna('analitico-geral', estadosRequerimento.CRIADO),
    9: this.montaColuna('analitico-geral', estadosRequerimento.DEFERIDO),
    10: this.montaColuna('analitico-geral', estadosRequerimento.EM_ANALISE),
    11: this.montaColuna('analitico-geral', estadosRequerimento.EM_COMPENSACAO),
    12: this.montaColuna('quantitativo-exigencia', estadosRequerimento.EM_EXIGENCIA),
    13: this.montaColuna('quantitativo-especial', estadosRequerimento.INDEFERIDO),
    14: this.montaColuna('analitico-geral', estadosRequerimento.EM_ANALISE_MEDICO),
    15: this.montaColuna('analitico-geral', estadosRequerimento.ALTERADO),
    16: this.montaColuna('analitico-geral', estadosRequerimento.EXIGENCIA_INDEFERIDO),
    17: this.montaColuna('analitico-geral', estadosRequerimento.INDEFERIDO_RATIFICADO),
  }

  analiticoDataFormatOptions = {
    1: this.montaColuna(null, null, 'cpf'),
  }

  quantExigenciasDataFormatOptions = {
    2: this.montaColuna('analitico-especial', estadosRequerimento.EM_EXIGENCIA),
  }

  quantEspecialDataFormatOptions = {
    2: this.montaColuna('analitico-especial'),
  }

  analiticoEspecialDataFormatOptions = {
    1: this.montaColuna(null, null, 'cpf'),
  }

  defineContainerStyle = () => {
    let width = this.state.colunasRelatorio.length * 150;
    if (width < 1140) {
      width = 1140;
    }
    return {
      width: `${width}px`,
    };
  };

  render() {
    let hidden = null;
    if (this.state.nomeRelatorio === 'Relatório Quantitativo de Exigências' ||
      this.state.nomeRelatorio === 'Relatório Quantitativo de Motivos') {
      hidden = [0];
    }
    const options = {
      noDataText: 'Nenhum resultado a ser exibido',
      hideSizePerPage: true,
      hidden,
    };
    return (
      <DtpContentContainer>
        <FiltroRelatorio
          handleSearchFilter={this.handlePesquisar}
          destinatarios={this.props.destinatarios}
          filtroModalidade
          rgps={this.isRgps()}
          tipo="requerimentos"
        />
        {
          this.state.nomeRelatorio !== '' ? (
            <Relatorio
              paramExibirBotaoRelatorioAnalitico={this.state.tipoRelatorio === 'quantitativo-especial' ||
                                                    this.state.tipoRelatorio === 'quantitativo-exigencia'}
              estado={this.state.estadoRequerimentoAtual}
              legend={this.state.nomeRelatorio}
              bordered
              headers={this.state.colunasRelatorio}
              data={this.state.listaResultados}
              options={options}
              pagination
              dataFormatOptions={this.state.dataFormatOptions}
              landscape
              voltarAction={this.handleVoltar}
              exigenciasCompletoAction={this.executaConsulta}
              containerStyle={this.defineContainerStyle()}
              rowAtual={this.state.rowAtual}
            />
          ) : null
        }
      </DtpContentContainer>
    );
  }
}

TelaRelatorioRequerimentos.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func,
  }).isRequired,
  auth: PropTypes.shape({
    userData: PropTypes.object,
    checkPermission: PropTypes.func,
  }).isRequired,
  destinatarios: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.number,
    label: PropTypes.string,
  })),
};

TelaRelatorioRequerimentos.defaultProps = {
  destinatarios: [],
};

// eslint-disable-next-line
const mapStateToProps = (state) => ({
  destinatarios: state.base.destinatarios,
});

export default connect(mapStateToProps)(TelaRelatorioRequerimentos);



// WEBPACK FOOTER //
// ./src/pages/relatorios/TelaRelatorioRequerimentos.jsx